import React, {  } from 'react';

import { listFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { ListFormatInput, ListFormatRuleSet } from './Intl.ListFormat';

export const IntlListFormatFormatToParts = () => (
	<IntlFunction
		input={ListFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/formatToParts"
		header="Intl.ListFormat.prototype.formatToParts"
		description="Returns an [Array](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) of objects representing the different components that can be used to format a list of values in a locale-aware fashion."
		options={listFormatOptions}
		ruleSet={ListFormatRuleSet}
		template="new Intl.ListFormat(##locale##, ##options##).formatToParts(##input:raw##)" />
);
